import React,{useState,useEffect, Children} from 'react'
import { useNavigate } from 'react-router-dom';
// import { baseURL } from '../Api/api';
import axios from 'axios'
import classes from '../css/RedirectPage.module.css'
import { updateStatusApi } from '../api/IntegrationAPi';

const Redirect = () => {

  const navigate = useNavigate()

    const [param,setParam] = useState(null)

    const queryParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of queryParams.entries()) {
      params[key] = value;
    }

    const UpdateMessage=async()=>{

      console.log('update message called')
      try{
        const data ={
          message:params.message,
          reason:params.error,
          ext_ref:params.requestid
        }
        const res = await axios.post(updateStatusApi,data)
        console.log(res);
      }
      catch(err){
        console.log(err)
      }
    }


   

useEffect(()=>{
  if(params?.message?.toLowerCase() == 'success'){
     UpdateMessage()
    navigate('/')
  }
  else{
     UpdateMessage()
  }

},[params])

// console.log(params);
 

  console.log(params,'params---------')

  return (
    <>
    {
      params?.message?.toLowerCase() == 'failure' &&
      
      
        <div  className={classes.container} >
         <div
      className={classes.sub_container}
      
    >
   
      <div
        class={classes.card}
      >
      <img src='/assets/images/fantasyGame.png' alt='' className={classes.img} />
      <br/>
      <h1 className={classes.heading} >KICKWIN</h1>
     <br/>
        <p class={classes.text}>
        ** You Failed to Subscribe!!
        <br/>
        Try Again Later!! **
        </p>
        <br/>
      </div>
      
    </div>
    </div>
   
    
    }
    </>
  )
}

export default Redirect
